import { useRanger } from "react-ranger";
import TextField from "../textFields/textField";
import "./rangeSlider.scss";

export default function RangeSlider(props: {
  score: number;
  values?: number[];
  onChange?: (e: number[] | undefined) => void;
}) {
  const { getTrackProps, ticks, handles } = useRanger({
    min: 0,
    max: props.score,
    stepSize: 1,
    values: props.values ?? [],
    ticks: [0, props.score],
    onChange: props.onChange,
  });

  function getNumberButton(text: string, onClick?: () => void) {
    return (
      <div style={{ fontSize: "16px", cursor: "pointer" }} onClick={onClick}>
        {text}
      </div>
    );
  }
  return (
    <div {...getTrackProps()} className="slider-container">
      <div
        className="slider-header"
        style={{ paddingBottom: props.values?.length && "1rem" }}
      >
        <p>Number of range</p>
        <TextField
          initialValue={((props.values?.length ?? 0) + 1).toString()}
          maxWidth={"100px"}
          prefix={getNumberButton("-", () =>
            props.onChange?.(
              [...(props.values ?? [])].slice(
                0,
                (props.values?.length ?? 1) - 1
              )
            )
          )}
          suffix={getNumberButton("+", () =>
            props.score > (props.values?.length ?? 0)
              ? props.onChange?.([0, ...(props.values ?? [])])
              : undefined
          )}
          textAlignment={"center"}
        />
      </div>
      {props.values?.length != 0 && (
        <div
          style={{
            paddingBottom: props.values?.length != 0 ? "1rem" : "",
            paddingTop: "17px",
          }}
        >
          {ticks.map(({ value, getTickProps }) => (
            <div {...getTickProps()}>
              <div className="slider-count">{value}</div>
            </div>
          ))}
          <div className="slider" {...getTrackProps({})}>
            {handles.map(({ value, getHandleProps }) => (
              <button className="slider-button" {...getHandleProps({})}>
                <div className="slider-button-count">{value}</div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
